import type { LangStrings } from './en';

export const pt: LangStrings = {
  back: 'VOLTAR',
  next: 'PRÓXIMO',
  retry: 'TENTAR DE NOVO',
  replay: 'REPETIR',
  sector: 'SETOR',
  sectors: 'SETORES',
  levels: 'NÍVEIS',
  cleared: 'CONCLUÍDO',
  open: 'ABERTO',
  locked: 'BLOQUEADO',
  tba: 'TBA',
  slot_reserved: 'RESERVADO',
  sfx_on: 'SFX ON',
  sfx_off: 'SFX OFF',
  reset_progress: 'APAGAR PROGRESSO',
  wiped_reloading: 'APAGADO, RECARREGANDO…',
  got_it: '› ENTENDI ‹',

  boot_eyebrow: 'PROTOCOLO CASCATA  //  BUILD',
  boot_tagline: 'UM TOQUE. UMA CASCATA. SEM REPETIÇÃO.',
  boot_subtitle: '信号崩壊  ·  LÓGICA DE CASCATA',
  boot_cta: '› TOQUE PARA INICIAR ‹',
  boot_region: 'REGIÃO ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // ONLINE',

  menu_header_subtitle: 'NØDUS / SELEÇÃO.SETOR',
  menu_engine_label: 'motor de colapso de sinal',
  menu_signals_down: 'sinais derrubados',
  menu_tap_chapter: 'TOQUE UM CAPÍTULO PARA ENTRAR',
  menu_language_label: 'IDIOMA',

  chapter_signals_down: 'sinais derrubados',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'CODA',
  chapter_coda_tagline: 'Nada de novo. Tudo combinado.',

  hud_tap_to_breach: '▾  toque qualquer nó para violar  ▾',
  hud_tap_to_skip: "pular  ▸▸",
  hud_drag_zoom_help: 'arraste para mover · roda/pinça para zoom',
  hud_required: 'NECESSÁRIO',
  hud_core_online: 'NÚCLEO ATIVO',
  hud_core_down: 'NÚCLEO CAÍDO',

  tut_tap_any_node: 'TOQUE QUALQUER NÓ',
  tut_they_all_work: 'todos funcionam aqui',

  brief_eyebrow: '◂ BRIEFING ▸',
  brief_title: 'UM TOQUE.\nUMA CASCATA.',
  brief_line_1: '› Você tem exatamente UM toque.',
  brief_line_2: '› Ele dispara uma reação em cadeia na rede.',
  brief_line_3: '› Derrube cada NECESSÁRIO (diamante ciano) para vencer.',
  brief_line_4: '› Nunca deixe um pulso tocar PROTEGIDO (vermelho).',
  brief_begin: '› INICIAR BRIEFING ‹',

  result_win_headline: 'SISTEMA COLAPSADO',
  result_fail_headline: 'CASCATA FALHOU',
  result_first_clear: '› PRIMEIRA VITÓRIA ‹',
  result_try_label: '› TENTE',
  result_cleared_suffix: 'CONCLUÍDO',
  result_aborted_suffix: 'EXECUÇÃO ABORTADA',
  result_win_body_template: '{ticks} ticks. {nodes} nós caídos.',

  fail_protected_overload: 'Nó protegido sobrecarregado. A cascata atingiu algo que não devia.',
  fail_forbidden_trigger: 'Uma linha proibida transportou um sinal. Disparou alarme severo.',
  fail_required_not_reached: 'Um nó necessário nunca recebeu pulso. A cadeia não o alcançou.',
  fail_required_under_threshold: 'Um necessário não recebeu pulsos suficientes. O decaimento matou o primeiro antes do segundo.',
  fail_core_not_collapsed: 'O núcleo sobreviveu. A cascata se dissipou antes de chegar.',
  fail_core_under_threshold: 'O núcleo recebeu pulsos mas não o suficiente, não convergiram a tempo.',
  fail_core_shielded: 'Pulsos do núcleo bloqueados. Um escudo ainda estava ativo.',
  fail_chain_died: 'A cadeia morreu antes de alcançar qualquer coisa.',
  fix_protected_overload: 'Escolha um iniciador cuja cascata nunca alcance o perigo vermelho. Trace as saídas primeiro.',
  fix_forbidden_trigger: 'Evite iniciadores que disparem PARA um cabo vermelho tracejado. O alarme dispara na hora.',
  fix_required_not_reached: 'Seu iniciador não conecta a esse nó. Olhe as setas, cabos direcionais fluem em um sentido só.',
  fix_required_under_threshold: 'Encontre uma rota que entregue dois pulsos àquele nó, um divisor ou dois caminhos convergentes resolvem.',
  fix_core_not_collapsed: 'Você precisa de mais convergência no núcleo. Divisores, capacitores e relés existem para alimentá-lo.',
  fix_core_under_threshold: 'Pulsos chegam lentos demais. Use divisores para empilhar acertos, ou faça todos chegarem no mesmo tick.',
  fix_core_shielded: 'Derrube cada escudo antes de qualquer tiro letal. Um cabo de atraso chegando tarde funciona bem.',
  fix_chain_died: 'Seu iniciador conecta apenas a um nó. Escolha um no meio da rede.',

  popup_new_node: '◂ NOVO TIPO DE NÓ ▸',
  popup_new_wire: '◂ NOVO TIPO DE CABO ▸',

  node_normal_title: 'NÓ',
  node_normal_tagline: 'A unidade base. Toque para iniciar uma cascata.',
  node_normal_b1: 'Colapsa no primeiro pulso que chega.',
  node_normal_b2: 'Dispara um pulso em cada cabo de saída aberto.',
  node_normal_b3: 'Sem limite, um acerto e ele se vai.',

  node_required_title: 'NECESSÁRIO',
  node_required_tagline: 'Você precisa colapsar cada NECESSÁRIO para vencer.',
  node_required_b1: 'Diamante ciano. Pulsa suave em repouso para você notar.',
  node_required_b2: 'Alguns precisam de 2+ pulsos na mesma janela.',
  node_required_b3: 'Falhe um só e a execução acaba.',
  node_required_note: 'Um pequeno anel de pontos mostra o progresso de carga.',

  node_protected_title: 'PROTEGIDO',
  node_protected_tagline: 'Toque nele e a execução inteira morre.',
  node_protected_b1: 'Cruz vermelha de perigo. Marcado com cantos.',
  node_protected_b2: 'Qualquer pulso aqui causa FALHA instantânea.',
  node_protected_b3: 'Planeje uma rota que nunca o alimente.',

  node_relay_title: 'RELÉ',
  node_relay_tagline: 'Abre cabos bloqueados ao colapsar.',
  node_relay_b1: 'Galão dourado. Seus alvos são cabos BLOQUEADOS tracejados.',
  node_relay_b2: 'Quando o relé cai, seus cabos bloqueados se abrem.',
  node_relay_b3: 'Útil para revelar uma rota até um nó guardado.',

  node_shield_title: 'ESCUDO',
  node_shield_tagline: 'Guarda-costas. Absorve golpes por outro nó.',
  node_shield_b1: 'Anel hexagonal verde ao redor do nó protegido.',
  node_shield_b2: 'Um pulso direto em nó escudado NÃO FAZ NADA.',
  node_shield_b3: 'Derrube o escudo primeiro, depois entregue o tiro fatal.',
  node_shield_note: 'Cabos de ATRASO (dourado tracejado) são perfeitos para um tiro pós-escudo.',

  node_splitter_title: 'DIVISOR',
  node_splitter_tagline: 'Multiplica pulsos em todas as saídas.',
  node_splitter_b1: 'Forquilha magenta. Um pulso entra → N pulsos por saída.',
  node_splitter_b2: 'A marca X mostra seu fator de divisão.',
  node_splitter_b3: 'Fornece os múltiplos acertos que um NÚCLEO de limite alto precisa.',

  node_capacitor_title: 'CAPACITOR',
  node_capacitor_tagline: 'Armazena um pulso, depois reemite, um buffer.',
  node_capacitor_b1: 'Símbolo amarelo de capacitor. Encaminha um pulso 3 ticks depois.',
  node_capacitor_b2: 'Trate-o como um ATRASO embutido na rota.',
  node_capacitor_b3: 'Permite que um pulso posterior chegue DEPOIS de um escudo cair.',

  node_core_title: 'NÚCLEO',
  node_core_tagline: 'O objetivo. Limite alto, decaimento rápido.',
  node_core_b1: 'Reator roxo. Precisa de muitos pulsos convergentes para cair.',
  node_core_b2: 'A carga DECAI, pulsos precisam chegar juntos.',
  node_core_b3: 'Frequentemente guardado por escudos. Derrube-os, depois inunde o núcleo.',
  node_core_note: 'Um nível com NÚCLEO é vencido colapsando-o. Necessários (se houver) também contam.',

  wire_directional_title: 'CABO DIRECIONAL',
  wire_directional_tagline: 'Condutor unidirecional. Ciano com ponta de seta.',
  wire_directional_b1: 'O pulso só viaja na direção da seta.',
  wire_directional_b2: 'Toque do lado errado da seta e nada flui.',
  wire_directional_b3: 'Siga as setas do seu iniciador até o fim.',

  wire_delay_title: 'CABO DE ATRASO',
  wire_delay_tagline: 'Dourado tracejado. O pulso chega 3 ticks depois.',
  wire_delay_b1: 'Útil para sincronia, entregue um pulso DEPOIS de um escudo cair.',
  wire_delay_b2: 'Ou para empilhar dois pulsos em um nó de limite alto.',
  wire_delay_b3: 'Erre o tempo e o primeiro pulso decai antes do segundo.',

  wire_locked_title: 'CABO BLOQUEADO',
  wire_locked_tagline: 'Cinza tracejado + cadeado. Fechado até algo abrir.',
  wire_locked_b1: 'Um RELÉ controla cada cabo bloqueado.',
  wire_locked_b2: 'Quando o relé colapsa, seus cabos bloqueados se abrem.',
  wire_locked_b3: 'Não desperdice toque tentando alimentar um diretamente.',

  wire_forbidden_title: 'CABO PROIBIDO',
  wire_forbidden_tagline: 'VERMELHO tracejado com cruz. Tocar = falha instantânea.',
  wire_forbidden_b1: 'Qualquer pulso, até de trânsito, ativa o alarme.',
  wire_forbidden_b2: 'Vigie esses nas saídas de cada iniciador.',
  wire_forbidden_b3: 'Escolha um iniciador cuja rota NUNCA toque vermelho.',

  wire_burn_title: 'CABO INCANDESCENTE',
  wire_burn_tagline: 'Laranja latão. Condutor de uso único, queima após um pulso.',
  wire_burn_b1: 'Carrega exatamente UM pulso, depois morre para sempre.',
  wire_burn_b2: 'Planeje seu uso único com cuidado, sem segunda chance.',
  wire_burn_b3: 'Uma vez queimado, nenhuma cascata pode atravessá-lo.',

  callout_required_crashed: 'NECESSÁRIO CAÍDO',
  callout_core_breached: 'NÚCLEO PERFURADO',
  callout_shield_dropped: 'ESCUDO CAÍDO',
  callout_relay_opened: 'RELÉ ABERTO',
  callout_protected_hit: 'PROTEGIDO ATINGIDO',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'Seu toque',
  result_map_broke: 'Falhou aqui',
  result_map_answer: 'Funciona',
  result_show_answer: 'Mostrar a resposta',
  menu_endless_line: 'Níveis gerados com três vidas. Quanto mais fundo, mais forte morde.',
  menu_best: 'Melhor LV {n}',
  menu_best_streak: 'Melhor LV {n}  ·  sequência ×{s}',
  menu_resume: 'Continuar LV {n}',
  menu_start: 'Começar LV 1',
  result_run_total: 'Total da corrida {n}',
  result_streak: 'Sequência ×{n}',
  result_streak_wins: '{n} vitórias seguidas',
  legend_title: 'Legenda',
  legend_nodes: 'NÓS',
  legend_wires: 'FIOS',
  legend_close: 'Toque em qualquer lugar para fechar',
  settings_sync_now: 'Sincronizar ({who})',
  settings_sign_in: 'Entre para sincronizar',
  settings_sign_out: 'Sair',

};
